import { Dialog, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { FC, memo } from 'react';

type Props = {
  open: boolean;
  handleApply: () => void;
  handleNotApply: () => void;
  handleCancel: () => void;
}

export const ConfirmDialog: FC<Props> = memo(({ open, handleApply, handleNotApply, handleCancel }) => (
  <Dialog
    sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
    maxWidth="sm"
    open={open}
  >
    <DialogContent dividers>
      <Typography>
        案件一覧に反映しますか？
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCancel}>
        キャンセル
      </Button>
      <Button onClick={handleNotApply}>
        反映しないで確定にする
      </Button>
      <Button onClick={handleApply}>
        反映して確定する
      </Button>
    </DialogActions>
  </Dialog>
));
